import { render, staticRenderFns } from "./ViewMatch.vue?vue&type=template&id=3b80a18a&"
import script from "./ViewMatch.vue?vue&type=script&lang=js&"
export * from "./ViewMatch.vue?vue&type=script&lang=js&"
import style0 from "./ViewMatch.vue?vue&type=style&index=0&id=3b80a18a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports